import { render } from "./Plants.vue?vue&type=template&id=3080b427&scoped=true"
import script from "./Plants.vue?vue&type=script&lang=js"
export * from "./Plants.vue?vue&type=script&lang=js"

import "./Plants.vue?vue&type=style&index=0&id=3080b427&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3080b427"

export default script